(($) => {
  $(() => {
    const $shouldBlur = $('#master, #mobile-menu');

    $(document).on('show.bs.modal', () => {
      $shouldBlur.addClass('blur');
    });

    $(document).on('hidden.bs.modal', () => {
      $shouldBlur.removeClass('blur');
    });
  });
})(jQuery);
